import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ISection } from '../../interfaces/scheduler_interfaces';

interface IRequestStateModel {
  scheduledSectionPendingSet: Set<ISection['id']>;
  isSwapPending: boolean;
  isRegistrationPending: boolean;
  isCampusPreferencePending: boolean;
  isMultiSectionsDropWithdrawPending: boolean;
  isMultiSectionsWaitlistPending: boolean;
}

export type RequestStateModel = ITypedModel<IRequestStateModel>;

angular.module('capability-ng-scheduler').factory('ngRequestStateModel', () => {
  return new Model<IRequestStateModel>({
    scheduledSectionPendingSet: new Set(),
    isSwapPending: false,
    isRegistrationPending: false,
    isCampusPreferencePending: false,
    isMultiSectionsDropWithdrawPending: false,
    isMultiSectionsWaitlistPending: false
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/request_state/models/request_state_model.ts